export default __webpack_public_path__ + "static/media/logo.2a4c1e42.png";